<template>
  <div class="ll-change-collapse-card">
    <div
      class="ll-change-collapse-card_title-wrap"
      @click="$_toggleClick()"
    >
      <div class="ll-change-collapse-card_des">
        <i
          v-if="systemIcon"
          class="title-icon"
          :leadingIcon="systemIcon"
        />
        <img
          v-if="systemImage"
          class="title-img"
          :src="systemImage"
          alt=""
        >
        <p class="ll-change-collapse-card_title">
          {{ $t('涉及水污染防治') }}
        </p>
      </div>
      <div class="ll-change-collapse-card_remark-wrap">
        <div
          class="ll-change-collapse-card_remark"
          :class="{white:taskComplete}"
        >
          <i
            v-if="isTasking && taskComplete"
            class="remark-icon icon-nav-assignment-outline"
          />
          <i
            v-else-if="isTasking"
            class="remark-icon icon-nav-assignment-outline"
          />
          <i
            v-else
            class="remark-icon icon-edit-pencil"
          />
          <i
            v-if="taskComplete"
            class="remark-icon icon-check"
          />
          <div
            v-else
            class="remark-number"
          >
            1
          </div>
        </div>
        <i
          v-if="collapseActive"
          class="icon-unfold-less ll-change-collapse-card_trailing-icon"
        />
        <i
          v-else
          class="icon-unfold-more ll-change-collapse-card_trailing-icon"
        />
      </div>
    </div>
    <slide-up-down
      :active="collapseActive"
      :duration="500"
    >
      <div class="ll-change-collapse-card_content">
        <div class="ll-change-collapse-card_content-item">
          <p class="content-item-title">
            {{ viewTitle }}
          </p>
          <p class="content-item-description">
            {{ viewContent }}
          </p>
          <LlFileList
            v-if="attaches.length > 0"
            two-item
            :attaches="attaches"
            :margin-top="20"
          />
        </div>
        <div class="ll-change-collapse-card_content-item">
          <p class="content-item-title">
            {{ evaluationTitle }}
          </p>
          <div class="content-item-taker">
            <LlAvatar
              v-if="evaluationTaker.name"
              :image="evaluationTaker.avatar"
              :text-label="evaluationTaker.name"
              font-size-lg
            />
            <WsTextChip001
              v-if="evaluationDate"
              icon-xl
              thin
              gray
              leading-icon="icon-time"
              :text-label="evaluationDate"
            />
          </div>
          <p class="content-item-description">
            {{ evaluationContent }}
          </p>
        </div>
        <div
          v-if="taskId && isTasking"
          class="ll-change-collapse-card_content-item border"
        >
          <LvEventCard
            :id="taskId"
            bold
            :title-size="1"
            type="task"
          />
        </div>
        <div
          v-if="isTasking"
          class="ll-change-collapse-card_content-item border"
        >
          <p class="content-item-title">
            {{ taskCreateTitle }}
          </p>
          <div class="btns-wrap">
            <p class="content-item-description">
              {{ taskCreateContent }}
            </p>
            <div class="btn">
              <WsButton001
                width-stretch
                leading-icon="icon-add-assignment"
              >
                {{ $t('建立任務') }}
              </WsButton001>
            </div>
          </div>
        </div>
      </div>
    </slide-up-down>
  </div>
</template>
<script>
export default {
  name: "LlChangeCollapseCard",
  props: {
    leadingIcon: {
      type: String,
      default: "",
    },
    attaches: {
      type: Array,
      default() {
        return [];
      },
    },
    systemImage: {
      type: String,
      default: "",
    },
    systemIcon: {
      type: String,
      default: "",
    },
    viewTitle: {
      type: String,
      default() {
        return this.$t("ESGoal建議應檢視項目");
      },
    },
    viewContent: {
      type: String,
      default() {
        return this.$t("無");
      },
    },
    evaluationTitle: {
      type: String,
      default() {
        return this.$t("相關領域負責人評估");
      },
    },
    evaluationContent: {
      type: String,
      default: "無",
    },
    evaluationTaker: {
      type: Object,
      default() {
        return {};
      },
    },
    isTasking: {
      type: Boolean,
      default: false,
    },
    evaluationDate: {
      type: String,
      default: "",
    },
    taskId: {
      type: Number,
      default: 0,
    },
    taskCreateTitle: {
      type: String,
      default() {
        return this.$t("建立任務");
      },
    },
    taskCreateContent: {
      type: String,
      default() {
        return this.$t(
          "你可以透過建立任務委派待辦事項給負責人員"
        );
      },
    },
    taskComplete: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    collapseActive: false,
  }),
  methods: {
    $_toggleClick() {
      this.collapseActive = !this.collapseActive;
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-change-collapse-card";
</style>